import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components'
import { useCourse, setCourse } from './hooks';
import { Typo, Button, SubMenu, SubMenuWrapper, Loading } from '../../ui';
import { useTranslation } from 'react-i18next';
import { useCourseById } from './hooks';

const CourseTitle = styled(Typo.SectionHeader)`
  align-self:center;
`

const CourseDetails = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { courseId } = useParams();
  const course = useCourse()

  // Validate courseId before making API calls
  const isValidCourseId = courseId && courseId !== 'undefined' && courseId !== 'null' && courseId !== '';

  const { course: courseData, error: courseError, isLoading } = useCourseById(courseId);

  // Keep tasks query to populate dependent views
  // useTasks({ courseId }, { skip: !isValidCourseId });

  // Handle course fetch errors
  useEffect(() => {
    if (courseError) {
      console.error('CourseDetails: Error fetching course', { courseId, error: courseError });
    }
  }, [courseError, courseId]);

  // Bridge: hydrate existing slice so current selectors/components keep working
  useEffect(() => {
    if (courseData) {
      dispatch(setCourse(courseData));
    }
  }, [courseData, dispatch, courseId]); // Depend on both ID and courseData

  // Handle invalid courseId - redirect or show error
  useEffect(() => {
    if (!isValidCourseId && courseId) {
      console.error('CourseDetails: Invalid courseId detected, redirecting', { courseId });
      navigate('/courses');
    }
  }, [isValidCourseId, courseId, navigate]);

  // Early return for invalid courseId
  if (!isValidCourseId) {
    console.log('CourseDetails: Invalid courseId, rendering minimal UI', { courseId });
    return (
      <SubMenuWrapper direction='column' align='flex-start'>
        <Button $asText onClick={() => navigate('/courses')} >
          {`< ${t('course.goBackToList')}`}
        </Button>
        <CourseTitle>{t('course.invalidCourse', 'Invalid Course')}</CourseTitle>
      </SubMenuWrapper>
    );
  }

  // Show loading state while course is being fetched
  if (isLoading && !course?.name) {
    return (
      <SubMenuWrapper direction='column' align='flex-start'>
        <Button $asText onClick={() => navigate('/courses')} >
          {`< ${t('course.goBackToList')}`}
        </Button>
        <Loading />
      </SubMenuWrapper>
    );
  }

  const navigationItems = [
    { label: t('globals.users'), 'value': 'users' },
    { label: t('globals.tasks'), 'value': 'tasks' },
    { label: t('globals.quiz'), 'value': 'quiz' },
    { label: t('globals.settings'), 'value': 'settings' }
  ]

  return (
    <>
      <SubMenuWrapper direction='column' align='flex-start'>
        <Button $asText onClick={() => navigate('/courses')} >
          {`< ${t('course.goBackToList')}`}
        </Button>
        <CourseTitle>{course?.name || courseData?.name || t('course.untitled', 'Untitled Course')}</CourseTitle>
        <SubMenu navigationItems={navigationItems} pathnameSplitIndex={3} />
      </SubMenuWrapper>
      <Outlet />
    </>
  );
};

export default CourseDetails;
